import { Tag, Typography, Flex } from 'antd';
import { XIcon } from '@phosphor-icons/react';
import styled from '@emotion/styled';

const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

interface IProposedTagsProps {
  tags: Array<string>;
  closable: boolean;
  onCloseTag?: (tag: string) => void;
}

const ProposedTags = ({ tags, closable, onCloseTag }: IProposedTagsProps) => (
  <div>
    <Typography.Text style={{ fontWeight: 400, fontSize: 12 }}>Proposed Tags</Typography.Text>
    <Flex vertical gap={4}>
      <TagsWrapper>
        {tags.map(tag => (
          <Tag
            key={tag}
            color="#F5E7FF"
            closable={closable}
            closeIcon={<XIcon style={{ color: '#171717' }} />}
            onClose={() => onCloseTag?.(tag)}
            style={{
              color: '#171717',
              fontWeight: 700,
              borderRadius: 20,
              opacity: 0.8,
              letterSpacing: 0.5,
              textTransform: 'uppercase',
            }}
          >
            {tag}
          </Tag>
        ))}
      </TagsWrapper>
    </Flex>
  </div>
);

export default ProposedTags;
